// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Back',
    change_password: 'Change Password',
    current_password: 'Current Password',
    new_password: 'New Password',
    repeat_password: 'Repeat Password',
    error_current_password: 'Current password must be supplied',
    error_new_password: 'Password must be at least 8 characters long and contain at least one uppercase character one lowercase character and one number',
    error_repeat_password: 'Password repeat must be the same with new password',
    error_worng_current_password: 'Current password is not valid',
    succeeded: 'Your password have now been changed successfully',
    failed: 'An error occurred.'
}
